import { Component, OnInit, Input, AfterViewInit } from '@angular/core'
import { AskModel } from './ask.model'
import { AskService } from './ask.service'
import { DomSanitizer } from '@angular/platform-browser'
import { AjaxService } from 'src/app/shared/ajax.service'

@Component({
  selector: 'app-ask',
  templateUrl: './ask.component.html'
})
export class AskComponent implements OnInit, AfterViewInit {
  model: AskModel
  constructor(private service: AskService,private sanitized: DomSanitizer, private ajax: AjaxService) { }

  ngOnInit() {
    this.model = new AskModel()

  }

  ngAfterViewInit() {
    var thos = this
    document.getElementById('2019010209175788323').removeEventListener('row_click', undefined)
    document.getElementById('2019010209175788323').addEventListener('row_click', function (e: any) {
      thos.load(e.detail.model.dats_vis[e.detail.i][0])
    })
  }

  load(ask_id: string) {
    var model = model
    this.ajax.execute({
      url: 'ask/ask_grid',
      data: { ask_id },
      auth: true,
      success: (post: any) => {
        let mdl = post.result.ask
        mdl.tbls = post.result.tbl
        for (let tbl of mdl.tbls)
          tbl.cinfos = post.result.cinfos.filter(x => x.table_schema == tbl.scm && x.table_name == tbl.nam)

        // mdl.clms = post.result.clm

        for (let i = 0; i < post.result.grid.length; i++) {
          let grd = post.result.grid[i]
          grd.ssty = this.sanitized.bypassSecurityTrustStyle(grd.sty)
          grd.sstyp = this.sanitized.bypassSecurityTrustStyle(grd.styp)
          // this.modelsum.push(new PagesumModel('grid', grd.id, i, grd.srt, grd.tit, grd.dis, grd.grp, grd.sstyp, grd.clsp, grd.row))
          grd.cols = []
          for (let col of post.result.column) {
            if (grd.id == col.grid_id) {
              grd.cols.push(col)
              if (col.tals) {
                let tbl = post.result.tbl.find(x => x.als == col.tals)
                if (tbl) {
                  col.scm = tbl.scm
                  col.tnam = tbl.nam
                }
                else {
                  col.scm = null
                  col.tnam = null
                }
              }
            }
            if (col.cmp == 8 || col.cmp == 10) {
              col.pip = `this.slice(val, '◙', 1)`

              if (grd.opts_flt) {
                let op = grd.opts_flt.find(x => x.id == col.id)
                if (op) col.opts_flt = op.opts
              }
            }

            if (col.cmp == 9) col.pip = `this.qlist(val, model.cols[ci].cnf)`
            col.ssty = this.sanitized.bypassSecurityTrustStyle(col.sty)
            col.sstyp = this.sanitized.bypassSecurityTrustStyle(col.styp)
          }
          if (grd.pars) {
            grd.pars = grd.pars.split(';')
            for (let i: number = 0; i < grd.pars.length; i++)
              grd.pars[i] = grd.pars[i].split(',')
          }
          grd.cols_vis = grd.cols.filter((x: { dis: number; }) => x.dis != 3)
          // if (grd.dis == 4) this.cmodalService.models.push(new CmodalModel('grid', grd.id, grd.tit, grd))
          grd.sta = 1
        }
        this.model = mdl
        this.model.grd = post.result.grid
      }
    })
  }
}
